import { PagePath } from './../models/page-model';
import { ProductConfigurationIds, CartItemsPkgIdDisplayOrder, ComponentsToShowZeroAmount } from './../models/cart-model';
import { of, forkJoin, Subject } from 'rxjs';
import { IQueueEntry, TrackJsErrorLogService, UtilitiesService } from '@legalzoom/business-formation-sdk';
import { CartResponse, CartRequest, OrderSource, CartService, IUserCart, GetCartBalanceByCartIdResponse, UpdateCartByQuestionnaireRequest, CartItemSource, CartDiscounts, CartItem, IUserCartItem, CartItemType, UpdateCartByCustomerIdResponse, UpdateCartByCustomerIdRequest, } from '@legalzoom/cart-sdk';
import { ProductName } from '../constants/product-domain';
import { flatMap, map } from 'rxjs/operators';
import { CartCreationStatus } from './event.service';
import { ProductComponentId } from '../models/cart-model';
import { Chapter } from '../models/page-model';
import * as i0 from "@angular/core";
import * as i1 from "@legalzoom/cart-sdk";
import * as i2 from "../state/app/app.service";
import * as i3 from "@legalzoom/business-formation-sdk";
import * as i4 from "@legalzoom/processing-order-sdk";
import * as i5 from "./questionnaire/questionnaire.service";
import * as i6 from "./tracking/sead.service";
import * as i7 from "./questionnaire/questionnaire-mapping.service";
import * as i8 from "@legalzoom/questionnaire-answer-sdk";
import * as i9 from "./event.service";
import * as i10 from "../state/cart/cart-state.service";
export class UserCartService {
    constructor(cartService, appService, utilitiesService, processingOrderService, trackJS, questionnaireService, seadService, questionnaireMappingService, questionnaireAnswerService, eventService, cartState) {
        this.cartService = cartService;
        this.appService = appService;
        this.utilitiesService = utilitiesService;
        this.processingOrderService = processingOrderService;
        this.trackJS = trackJS;
        this.questionnaireService = questionnaireService;
        this.seadService = seadService;
        this.questionnaireMappingService = questionnaireMappingService;
        this.questionnaireAnswerService = questionnaireAnswerService;
        this.eventService = eventService;
        this.cartState = cartState;
        this.userCartChange = new Subject();
        this.cartResponse = new CartResponse();
    }
    get cartResponse() {
        return this.cartState.cartResponse;
    }
    set cartResponse(value) {
        this.cartState.cartResponse = value;
    }
    get userCart() {
        return this.cartState.cart;
    }
    set userCart(value) {
        this.cartState.cartId = value.cartId;
        this.cartState.cart = value;
        const app = this.appService.app;
        app.cartId = value.cartId;
        app.cart = value;
        this.appService.app = app;
    }
    updateCartAndProcessingOrderByCustomerId(existingCustomerId, updatedCustomerId, updatedCustomerInfo) {
        return forkJoin([
            this.updateCartByCustomerId(existingCustomerId, updatedCustomerId),
            this.updateProcessingOrderByCustomerId(existingCustomerId, updatedCustomerId)
        ]).pipe(flatMap(result => {
            return this.updateCustomerInfoInAppService(updatedCustomerInfo);
        }));
    }
    updateCartByCustomerId(existingCustomerId, updatedCustomerId) {
        const updateCartByCustomerIdRequest = {
            customerId: updatedCustomerId,
            updatedBy: updatedCustomerId.toString()
        };
        return this.cartService.updateCartByCustomerId(this.appService.app.cartId, updateCartByCustomerIdRequest, existingCustomerId);
    }
    prepareCreateNewCart() {
        const that = this;
        return {
            name: 'prepareCreateNewCart ' + this.constructor.name,
            pre: () => {
                this.eventService.updateCartCreationStatus(CartCreationStatus.Pending);
                return that.createNewCart();
            },
            post: (response) => {
                if (response) {
                    const app = that.appService.app;
                    app.cartId = response.cart.cartId;
                    const cartItem = response.cart.cartItems.find(ci => ci.processingOrderId !== null);
                    app.processingOrderId = cartItem.processingOrderId;
                    that.appService.app = app;
                    that.cartResponse = response;
                    that.questionnaireService.llc.currentView = Chapter.Name + '/' + PagePath.BusinessState;
                    this.eventService.updateCartCreationStatus(CartCreationStatus.Created);
                }
            },
            error: (error) => {
                console.log(error.message);
                this.eventService.updateCartCreationStatus(CartCreationStatus.Error);
                this.trackJS.track(ProductName.LLC, 'user-cart.service', error);
                console.log('--failed to create cart, proceeding with error--');
                return of(null);
            }
        };
    }
    createNewCart() {
        if (!this.questionnaireService.llc.entityState) {
            this.questionnaireService.llc.entityState = 'Alaska';
        }
        const cartRequest = {
            processId: this.appService.app.processId,
            customerId: this.appService.app.customerId,
            orderSourceId: OrderSource.legalZoom,
            checkOpenedCart: true,
            stateId: this.questionnaireService.llc.entityState.replace(/ /g, '').replace('.', ''),
            defaultPackageConfigurationId: '0'
        };
        return this.cartService.createCart(cartRequest, this.appService.app.customerId);
    }
    updateProcessingOrderByCustomerId(existingCustomerId, updatedCustomerId) {
        const updateProcessingOrderRequest = {
            customerId: updatedCustomerId,
            stateId: null,
            isQuestionnaireCompleted: null,
            postOption: null,
            shippingMethodId: null,
            lastPageVisited: null,
            comment: null
        };
        return this.processingOrderService.updateProcessingOrder(this.appService.app.processingOrderId, updateProcessingOrderRequest, existingCustomerId);
    }
    updateCustomerInfoInAppService(updatedCustomerInfo) {
        const app = this.appService.app;
        app.customerId = updatedCustomerInfo.customer.customerId;
        app.loginEmail = updatedCustomerInfo.customer.emailId;
        app.sessionId = updatedCustomerInfo.session.sessionId;
        app.accessToken = updatedCustomerInfo.session.accessToken;
        this.appService.app = app;
        this.utilitiesService.saveCookies(this.appService.app.sessionId, this.appService.app.accessToken, this.appService.app.customerId);
        return of(updatedCustomerInfo);
    }
    trackPackage(pkgConfigId) {
        let selectedPackageName = '';
        switch (pkgConfigId) {
            case ProductConfigurationIds.economyLLCPackage:
                selectedPackageName = 'Economy LLC';
                break;
            case ProductConfigurationIds.standarLLCPackage:
                selectedPackageName = 'Standard LLC';
                break;
            case ProductConfigurationIds.expressGoldLLCPackage:
                selectedPackageName = 'Express Gold LLC';
                break;
            case ProductConfigurationIds.tier1LLCPackage:
                selectedPackageName = 'LLC - Get Me Started';
                this.questionnaireService.llc.legalAdvice = false;
                break;
            case ProductConfigurationIds.tier2LLCPackage:
                selectedPackageName = 'LLC - Support Me';
                this.questionnaireService.llc.legalAdvice = true;
                break;
            case ProductConfigurationIds.tier3LLCPackage:
                selectedPackageName = 'LLC - Help Me Grow';
                // defaulting value since page is skipped
                this.questionnaireService.llc.legalAdvice = true;
                break;
        }
        this.questionnaireService.llc.packageSelected = pkgConfigId;
        this.seadService.TrackingObject.pkgSelected = selectedPackageName;
        this.seadService.PushToTealium();
    }
    getUpdatedCart(cartId, token, customerId) {
        return this.getMappedCartWithBalance(cartId, token, customerId).pipe(map(res => {
            return this.getCartModelFromApiData(res.updateCartResponse, res.cartBalanceResponse);
        }));
    }
    getMappedCartWithBalance(cartId, token, customerId) {
        const mapping = this.questionnaireMappingService.doMapping(this.questionnaireService.llc, this.appService.app.processingOrderId);
        const answerRequest = {
            questionnaireFieldGroupAnswers: {
                userOrderId: mapping.userOrderId,
                questionnaireId: this.appService.questionnaireId,
                fieldAnswers: mapping.fieldAnswers,
                groupAnswers: [] // mapping.groupAnswers
            }
        };
        const updateCartRequest = {
            cartItemSource: CartItemSource.userAction,
            changedBy: customerId.toString(),
            fieldAnswers: null,
            groupAnswers: null
        };
        // use this code for debugging RYO page
        // return this.cartService.getCart(cartId, customerId, token).pipe(flatMap(updateCartResponse => {
        //   return this.cartService.getCartBalanceByCartId(cartId, customerId, token)
        //     .pipe(map((cartBalanceResponse) => {
        //       return {
        //         updateCartResponse, cartBalanceResponse
        //       };
        //     }));
        // }));
        return this.questionnaireAnswerService
            .saveAndGetMappedUserAnswers(answerRequest, this.appService.app.questionnaireId, customerId)
            .pipe(flatMap((answerResponse) => {
            updateCartRequest.fieldAnswers =
                answerResponse.questionnaireFieldGroupAnswers.fieldAnswers;
            updateCartRequest.groupAnswers =
                answerResponse.questionnaireFieldGroupAnswers.groupAnswers;
            return this.cartService
                .updateCartByQuestionnaire(cartId, updateCartRequest, customerId)
                .pipe(flatMap((updateCartResponse) => {
                return this.cartService
                    .getCartBalanceByCartId(cartId, customerId)
                    .pipe(map(cartBalanceResponse => {
                    return {
                        updateCartResponse,
                        cartBalanceResponse
                    };
                }));
            }));
        }));
    }
    getCartModelFromApiData(updateCartResponse, cartBalanceResponse) {
        //  const isMobileMode = this.isMobileMode();
        // removes cancelled cart items which we do not need
        updateCartResponse.cart.cartItems = updateCartResponse.cart.cartItems.filter(item => !item.isCancelled);
        const installementPrice = this.getCartInstallmentFee(cartBalanceResponse);
        const promoCode = this.getCartPromoCode(cartBalanceResponse);
        this.insertCompanyDetailsCartItem(updateCartResponse);
        this.insertOAEinBL(updateCartResponse);
        this.insertSalesTaxAndDigitalDownloadDetails(updateCartResponse);
        this.addBPPToCart(updateCartResponse, ProductConfigurationIds.economyLLCPackage, ProductConfigurationIds.economyLLCShipping);
        this.insertUnselectedPackages(updateCartResponse);
        let cartItems = this.getCartItemsViewModel(updateCartResponse);
        cartItems = cartItems.sort((a, b) => a.rank - b.rank);
        return {
            cartId: updateCartResponse.cart.cartId,
            packageTitle: '',
            dueNow: cartBalanceResponse.cartBalance < 0 ? 0 : cartBalanceResponse.cartBalance,
            discount: cartBalanceResponse.totalDiscount,
            cartItems,
            installmentAmount: installementPrice,
            storeCredit: cartBalanceResponse.storeCreditAvailable,
            promoCode,
            isThreePay: updateCartResponse.cart.cartFlags.threePay,
        };
    }
    insertUnselectedPackages(cartRes) {
        if (cartRes.cart.cartItems.findIndex(x => x.productConfigurationId === ProductConfigurationIds.registeredAgent
            || x.productConfigurationId === ProductConfigurationIds.registeredAgent_199
            || x.productConfigurationId === ProductConfigurationIds.registeredAgent_249)
            === -1) {
            cartRes.cart.cartItems.push(this.getApiCartItem(ProductComponentId.custom_RegisteredAgent_NoThanks, 'LegalZoom Registered Agent - No thanks', ProductConfigurationIds.custom_RegisteredAgent_details));
        }
        if (cartRes.cart.cartItems.findIndex(x => x.productConfigurationId === ProductConfigurationIds.essentialComplianceTaxPreparationPackage)
            === -1) {
            cartRes.cart.cartItems.push(this.getApiCartItem(ProductComponentId.custom_TotalCompliance, 'Total Compliance - No thanks', ProductConfigurationIds.custom_Total_Compliance));
        }
        // TODO check if we need to add this
        // if (cartRes.cart.cartItems.findIndex( x => x.productConfigurationId === ProductConfigurationIds.bapAnnualTax )
        // === -1) {
        //   // Add tax
        //   cartRes.cart.cartItems.push(
        //     this.getApiCartItem(ProductComponentId.Custom_Affordable_Tax, 'Affordable Tax - No thanks', ProductConfigurationIds.Custom_Affordable_Tax)      );
        // }
        const taxAndLegalPkgs = [
            ProductConfigurationIds.bapMonthlyLegal,
            ProductConfigurationIds.bapMonthlyLegalWisconsin,
            ProductConfigurationIds.bapMonthlyLegalProtect,
            ProductConfigurationIds.bapMonthlyLegalProtectWisconsin
        ];
        if (cartRes.cart.cartItems.findIndex(x => taxAndLegalPkgs.includes(x.productConfigurationId)) === -1) {
            // Add legal
            cartRes.cart.cartItems.push(this.getApiCartItem(ProductComponentId.custom_LegalProtext_SmartEmployer, this.questionnaireService.llc.hireEmployees === 'no' ? 'Legal Protect - No thanks' : 'Smart Employer - No thanks', this.getAnnualLegalProductConfigurationId(this.questionnaireService.llc.entityState), 0, false, '', CartItemType.CrossSellAndAddOn_Offer));
        }
    }
    getAnnualLegalProductConfigurationId(entityState) {
        if (this.questionnaireService.llc.hireEmployees !== 'no') {
            return entityState && entityState.toLowerCase() === 'wisconsin' ? ProductConfigurationIds.bapMonthlyLegalWisconsin : ProductConfigurationIds.bapMonthlyLegal;
        }
        else {
            return entityState && entityState.toLowerCase() === 'wisconsin' ? ProductConfigurationIds.bapMonthlyLegalProtectWisconsin : ProductConfigurationIds.bapMonthlyLegalProtect;
        }
    }
    getCartItemsViewModel(cartData) {
        return cartData.cart.cartItems.map(item => {
            const updatedContent = this.renameCartItem(item);
            return {
                productConfigurationId: item.productConfigurationId,
                productComponentId: item.productComponentId,
                type: item.productTypeId,
                title: updatedContent.title != null ? updatedContent.title : item.productName,
                description: null,
                details: updatedContent.intro && updatedContent.body
                    ? {
                        intro: updatedContent.intro,
                        body: updatedContent.body,
                        showBody: false
                    }
                    : null,
                amount: item.extendedPrice,
                hideOnRYO: null,
                hideEditLink: null,
                showZeroAmount: ComponentsToShowZeroAmount.findIndex(c => c === item.productConfigurationId) > -1,
                rank: CartItemsPkgIdDisplayOrder.indexOf(item.productConfigurationId) === -1
                    ? 0
                    : CartItemsPkgIdDisplayOrder.indexOf(item.productConfigurationId),
                isShowAmountText: null,
                amountText: null,
                isSelected: null,
                subItems: null,
            };
        });
    }
    renameCartItem(cartItem) {
        const updatedContent = {
            title: null,
            intro: null,
            body: null
        };
        switch (cartItem.productConfigurationId) {
            case ProductConfigurationIds.tier1LLCPackage:
                updatedContent.title = 'Get Me Started';
                break;
            case ProductConfigurationIds.tier2LLCPackage:
                updatedContent.title = 'Support Me';
                break;
            case ProductConfigurationIds.tier3LLCPackage:
                updatedContent.title = 'Help Me Grow';
                break;
            case ProductConfigurationIds.economyLLCStateFilingFee:
            case ProductConfigurationIds.standardLLCStateFilingFee:
            case ProductConfigurationIds.goldExpressLLCStateFilingFee:
            case ProductConfigurationIds.standardFilingFee:
                updatedContent.title = this.questionnaireService.llc.entityState ? `${this.questionnaireService.llc.entityState} filing fee (This is the admin fee charged by the State)` : cartItem.productName;
                break;
            case ProductConfigurationIds.registeredAgent:
            case ProductConfigurationIds.registeredAgent_199:
            case ProductConfigurationIds.registeredAgent_249:
                updatedContent.title = 'LegalZoom Registered Agent (No fees until documents sent to state)';
                updatedContent.intro = '(No fees until documents sent to state)';
                updatedContent.body = 'LegalZoom\'s Registered Agent Service only starts when your LLC is submitted to state.'
                    + ' When we receive official notification that your LLC has been registered, your card will automatically be charged $159.'
                    + ' The service renews automatically each year, billed to your card, for the service price (currently $159).'
                    + ' You may cancel online or by calling us at (844) 962-7490. You will first need to appoint a new RA for your business.';
                break;
            case ProductConfigurationIds.expediteFilingFee:
            case ProductConfigurationIds.standardExpediteFilingFee:
                updatedContent.title = `${this.questionnaireService.llc.entityState} expedited fee + filing fee`;
                break;
            case ProductConfigurationIds.processingExpedited:
                updatedContent.title = 'Expedited Processing';
                break;
            case ProductConfigurationIds.essentialComplianceTaxPreparationPackage:
                updatedContent.title = 'Total Compliance';
                updatedContent.intro = '(10 days included)';
                updatedContent.body = 'This package is offered for 10 days. After the 10-day period, benefits continue automatically for the same term and rate unless otherwise notified.'
                    + ' Cancel online or by calling (888) 310-0151. For full details, please see our'
                    + ' <a href="http://www.legalzoom.com/legal/product-service-terms/supplemental-terms-of-service-for-advantage-subscriptions" target="_blank">Subscription Terms</a>'
                    + ' and <a href="https://www.legalzoom.com/legal/product-service-terms/legal-plan-contract" target="_blank">Legal Plan Contract</a>.';
                break;
            case ProductConfigurationIds.bapAnnualTax:
                updatedContent.intro = '(10 days included)';
                updatedContent.body = 'This package is offered as a trial for 10 days.'
                    + ' After the 10-day trial period, benefits continue automatically for the same term and rate unless otherwise notified.'
                    + ' Cancel online or by calling (888) 310-0151. For full details, please see our'
                    + ' <a href="http://www.legalzoom.com/legal/product-service-terms/supplemental-terms-of-service-for-advantage-subscriptions" target="_blank">Subscription Terms</a>'
                    + ' and <a href="https://www.legalzoom.com/legal/product-service-terms/legal-plan-contract" target="_blank">Legal Plan Contract</a>.';
                break;
            case ProductConfigurationIds.bapMonthlyLegal:
            case ProductConfigurationIds.bapMonthlyLegalWisconsin:
                updatedContent.intro = '(10 days included) ';
                updatedContent.body = 'This package is offered as a trial for 10 days.'
                    + ' After the 10-day trial period, benefits continue automatically for the same term and rate unless otherwise notified.'
                    + ' Cancel online or by calling (888) 310-0151. For full details, please see our'
                    + ' <a href="http://www.legalzoom.com/legal/product-service-terms/supplemental-terms-of-service-for-advantage-subscriptions" target="_blank">Subscription Terms</a>'
                    + ' and <a href="https://www.legalzoom.com/legal/product-service-terms/legal-plan-contract" target="_blank">Legal Plan Contract</a>.';
                break;
            case 2400:
                updatedContent.intro = 'Filing Fee';
                updatedContent.body = '';
                break;
            case 4529:
                updatedContent.intro = '';
                updatedContent.body = '';
                break;
            case ProductConfigurationIds.salesTax:
                updatedContent.title = 'Sales Tax';
                updatedContent.intro = '';
                updatedContent.body = '';
                break;
            case ProductConfigurationIds.salesTax_details:
                updatedContent.title = 'We’ve got you covered!';
                updatedContent.intro = '';
                updatedContent.body = '';
                break;
            // TODO add details for digital download
            //  case ProductConfigurationIds.digitalDownload2_details:
            //  break;
            default:
                break;
        }
        return updatedContent;
    }
    getCartInstallmentFee(cartBalance) {
        const installmentFee = 2;
        if (cartBalance.cartInstallments) {
            const prices = [
                cartBalance.cartInstallments.firstInstallment.installmentAmount,
                cartBalance.cartInstallments.secondInstallment.installmentAmount,
                cartBalance.cartInstallments.thirdInstallment.installmentAmount
            ];
            return Math.max(...prices) + installmentFee;
        }
        return 0;
    }
    getCartPromoCode(cartBalance) {
        if (cartBalance.cartDiscounts) {
            const discount = cartBalance.cartDiscounts.find(d => d.discountCode && d.discountCode.length > 0);
            if (discount) {
                return discount.discountCode;
            }
        }
        return null;
    }
    insertCompanyDetailsCartItem(cartRes) {
        const companyRowItem = this.getApiCartItem(ProductComponentId.custom_Company, 'Company details', ProductConfigurationIds.custom_Company);
        const entityNameRowItem = this.getApiCartItem(ProductComponentId.custom_EntityName, this.questionnaireService.llc.entityName, ProductConfigurationIds.custom_EntityName);
        cartRes.cart.cartItems.unshift(companyRowItem, entityNameRowItem);
    }
    getApiCartItem(productComponentId, productName, productConfigurationId = 0, extendedPrice = 0, isShowAmountText = false, amountText = '', productTypeId = 0) {
        return {
            cartItemId: 0,
            parentCartItemId: 0,
            productComponentId,
            productConfigurationId: productConfigurationId != null ? productConfigurationId : 0,
            relationshipTypeId: 0,
            productName,
            productTypeId: 0,
            basePrice: 0,
            extendedPrice,
            adjustedPrice: 0,
            quantity: 0,
            processingOrderId: 0,
            isPrePaid: false,
            shouldDisplayOnBill: false,
            isCancelled: false,
            productBasePriceId: 0,
            productPriceAdjustment: 0,
            stateId: 0,
            countyId: 0,
            cartItemSource: '',
            sourceOrderItemId: '',
            lineNumber: 0,
            dateCreated: '',
            createdBy: '',
            dateUpdated: '',
            updatedBy: ''
        };
    }
    insertSalesTaxAndDigitalDownloadDetails(cartRes) {
        cartRes.cart.cartItems.push(this.getApiCartItem(ProductComponentId.custom_SalesTax, 'Sales Tax', ProductConfigurationIds.salesTax, 0));
        cartRes.cart.cartItems.push(this.getApiCartItem(ProductComponentId.custom_SalesTaxDetails, 'We’ve got you covered!', ProductConfigurationIds.salesTax_details, 0));
        cartRes.cart.cartItems.push(this.getApiCartItem(ProductComponentId.custom_DigitalDownload2_details, 'All your documents in one convenient location +<br />1 TB of free cloud storage.', ProductConfigurationIds.digitalDownload2_details, 0));
    }
    // this method combines (OA/EIN/Business Licenses) into one line item
    insertOAEinBL(cartRes) {
        const oAIndex = cartRes.cart.cartItems.findIndex(i => i.productComponentId === ProductComponentId.operatingAgreement);
        const einIndex = cartRes.cart.cartItems.findIndex(i => i.productComponentId === ProductComponentId.ein);
        const blIndex = cartRes.cart.cartItems.findIndex(i => i.productComponentId === ProductComponentId.businessLicense);
        let cartItemTotal = 0;
        let cartItemName = '';
        if (oAIndex === -1) {
            cartItemName += 'Essential documents - No Thanks';
        }
        else {
            if (oAIndex > -1) {
                cartItemName += 'Operating Agreement';
                cartItemTotal += cartRes.cart.cartItems[oAIndex].extendedPrice;
            }
            if (einIndex > -1) {
                cartItemName += ', EIN';
                cartItemTotal += cartRes.cart.cartItems[einIndex].extendedPrice;
            }
            if (blIndex > -1) {
                cartItemName += ', Business Licenses';
                cartItemTotal += cartRes.cart.cartItems[blIndex].extendedPrice;
            }
        }
        cartRes.cart.cartItems.push(this.getApiCartItem((oAIndex === -1) ? ProductComponentId.custom_OAEinBL_NoThanks : ProductComponentId.custom_OAEinBL, cartItemName, (oAIndex === -1) ? ProductConfigurationIds.custom_OAEinBL_NoThanks : ProductConfigurationIds.custom_OAEinBL, cartItemTotal));
    }
    addBPPToCart(cartRes, configId, shipId) {
        const isEconomyPackage = cartRes.cart.cartItems.some(x => (x.productConfigurationId === configId));
        const hasProfPrintShipping = cartRes.cart.cartItems.some(x => x.productConfigurationId === shipId);
        if (isEconomyPackage && !hasProfPrintShipping) {
            const itemToAdd = this.getApiCartItem(ProductComponentId.custom_ProfessionPrint, 'Professional Printing - Standard', shipId, 0, false, '', CartItemType.ShippingItems);
            cartRes.cart.cartItems.splice(4, 0, itemToAdd);
        }
        else if (hasProfPrintShipping) {
            // Remove Prof print item and add it to proper position to display it on UI
            const shippingItemIndex = cartRes.cart.cartItems.findIndex(x => x.relationshipTypeId === CartItemType.ShippingItems
                && x.productConfigurationId === shipId);
            const removedItem = cartRes.cart.cartItems.splice(shippingItemIndex, 1);
            cartRes.cart.cartItems.splice(4, 0, removedItem[0]);
            this.questionnaireService.llc.professionalPrintSelected = true;
        }
    }
    prepareGetCartById(context, appService, cartId, customerId, productName) {
        const that = this;
        return {
            name: 'prepareGetCartById cart.service ' + context.constructor.name,
            pre: () => {
                return that.cartService.getCart(cartId, customerId);
            },
            post: (response) => {
                const appState = appService.app;
                if (!!response) {
                    appState.cartId = response.cart.cartId;
                    context.cart = response.cart;
                }
                else {
                    appState.cartId = 0;
                    appState.processingOrderId = 0;
                }
                appService.app = appState;
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(productName, 'user-cart.service' + context.constructor.name, error);
                return of(null);
            }
        };
    }
    savePackageSelected(pkgConfigId) {
        let selectedPackageName = '';
        switch (pkgConfigId) {
            case ProductConfigurationIds.economyLLCPackage:
                selectedPackageName = 'Economy LLC';
                break;
            case ProductConfigurationIds.standarLLCPackage:
                selectedPackageName = 'Standard LLC';
                break;
            case ProductConfigurationIds.expressGoldLLCPackage:
                selectedPackageName = 'Express Gold LLC';
                break;
            case ProductConfigurationIds.tier1LLCPackage:
                selectedPackageName = 'LLC - Get Me Started';
                this.questionnaireService.llc.legalAdvice = false;
                break;
            case ProductConfigurationIds.tier2LLCPackage:
                selectedPackageName = 'LLC - Support Me';
                this.questionnaireService.llc.legalAdvice = true;
                break;
            case ProductConfigurationIds.tier3LLCPackage:
                selectedPackageName = 'LLC - Help Me Grow';
                // defaulting value since page is skipped
                this.questionnaireService.llc.legalAdvice = true;
                break;
        }
    }
}
UserCartService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserCartService_Factory() { return new UserCartService(i0.ɵɵinject(i1.CartService), i0.ɵɵinject(i2.AppService), i0.ɵɵinject(i3.UtilitiesService), i0.ɵɵinject(i4.ProcessingOrderService), i0.ɵɵinject(i3.TrackJsErrorLogService), i0.ɵɵinject(i5.QuestionnaireService), i0.ɵɵinject(i6.SEADService), i0.ɵɵinject(i7.QuestionnaireMappingService), i0.ɵɵinject(i8.QuestionnaireAnswerService), i0.ɵɵinject(i9.EventService), i0.ɵɵinject(i10.CartStateService)); }, token: UserCartService, providedIn: "root" });
